import PeSingleChoice from '../../components/PeSingleChoice';
import PeExtraField from '../../components/PeExtraField';
import PePricingOption from '../../components/PePricingOption';
import PeMoreInfo from '../../components/PeMoreInfo';
// import PeMoreInfo from '../components/PeMoreInfo';

const options = {
  yes_no: [{
    label: 'Yes',
    value: 'yes'
  }, {
    label: 'No',
    value: 'no'
  }]
}

export const productChoiceStepField = [
  // {
  //   name: "indicative_pricing",
  //   component: PeSingleChoice,
  //   dependOn: "{\"choice_type_install\":\"no_replace_system\", \"subsidies\":\"\"}",
  //   props: {
  //     label: "",
  //     required: true,
  //     options: options.yes_no,
  //     sm: 2,
  //     initValue: "Indicative Pricing for No HWS - Sanden Quote App",
  //   },
  //   condition: [{
  //       value: "yes",
  //       fieldChild: [{
  //         name: "product_choice",
  //         component: PePricingOption,
  //         props: {
  //           label: "Product choice",
  //           required: true,
  //         },
  //       }, {
  //         name: "add_extras",
  //         component: PeSingleChoice,
  //         dependOn: "product_choice",
  //         props: {
  //           label: "Add Extras",
  //           required: true,
  //           options: options.yes_no,
  //           sm: 2,
  //           isAuth: true,
  //         },
  //       }, {
  //         name: "formchoice_extra",
  //         dependOn: "add_extras",
  //         dependOnValue: "yes",
  //         component: PeExtraField,
  //         props: {
  //           label: "Choice Extras",
  //           required: true,
  //         }
  //       }]
  //     }, {
  //       value: "no",
  //       fieldChild: [
  //         {
  //           name: "indicative_pricing_moreinfo",
  //           component: PeMoreInfo,
  //           props: {
  //             button: {
  //               label: "Get Free Quote",
  //               link: "#",
  //             },
  //             type: "warn",
  //             label: "Please get in touch by filling our get a free quote page, or alternatively email us info@pure-electric.com.au or give us a call 1300 86 78 73",
  //           },
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    name: "indicative_elec_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"electric_type\", \"product_choice_type\":\"electric_storage\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Electric",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_elec_gravity_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"electric_type\", \"product_choice_type\":\"gravity_feed\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Electric Gravity Feed",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_gas_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"gas_type\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Gas",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_heatpump_integrated_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"heatpump_type\", \"product_choice_type\":\"integrated_heatpump\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Heat Pump Integrated",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_heatpump_split_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"heatpump_type\", \"product_choice_type\":\"split_heatpump\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Heat Pump Split",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_solar_ground_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"solar_type\", \"product_choice_type\":\"ground_tank\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Solar Ground Tank",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_solar_rooftop_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"solar_type\", \"product_choice_type\":\"rooftop_tank\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Solar Roof Tank",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_lpg_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"lpg_type\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS LPG",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_wood_moreinfo",
    dependOn: "{\"choice_type_install\":\"replace_system\", \"choice_type_product\":\"wood_type\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing - Replace HWS Wood",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_nohws_moreinfo",
    dependOn: "{\"choice_type_install\":\"no_replace_system\", \"subsidies\":\"\"}",
    component: PeMoreInfo,
    props: {
      label: "",
      initValue: "Indicative Pricing for No HWS - Sanden Quote App",
      source: "note",
      type: "notice",
      headTitle: "Pure Electric Notes"
    },
  },
  {
    name: "indicative_pricing",
    dependOn: "subsidies",
    component: PeSingleChoice,
    props: {
      label: "Ready for indicative pricing?",
      required: true,
      options: options.yes_no,
      sm: 2,
    },
  },
  {
    name: "indicative_no_moreinfo",
    dependOn: "indicative_pricing",
    dependOnValue: "no",
    component: PeMoreInfo,
    props: {
      button: {
        label: "Get Free Quote",
        link: "#",
      },
      type: "warn",
      label: "Please get in touch by filling our get a free quote page, or alternatively email us info@pure-electric.com.au or give us a call 1300 86 78 73",
    },
  },
  {
    name: "product_choice",
    dependOn: "indicative_pricing",
    dependOnValue: "yes",
    component: PePricingOption,
    props: {
      label: "Product choice",
      required: true,
    },
  }, 
  {
    name: "add_extras",
    component: PeSingleChoice,
    dependOn: "product_choice",
    props: {
      label: "Add Extras",
      required: true,
      options: options.yes_no,
      sm: 2,
      isAuth: true,
    },
  }, {
    name: "formchoice_extra",
    dependOn: "add_extras",
    dependOnValue: "yes",
    component: PeExtraField,
    props: {
      label: "Choice Extras",
      required: true,
    }
  }
]